export default "__VITE_PUBLIC_ASSET__d19bf6c0__"